import React, { useEffect, useState } from 'react';
import { Container, Card, Alert, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Header from '~/Components/Header/Header';
import Loading from '~/Components/Loading';
import CarteiraService from './carteiraContaCapitalService';
import CarteiraDualList from './CarteiraDualList';
import CarteiraResultadoTabela from './CarteiraResultadoTabela';

// W-0627 — Página Carteira por Conta Capital (GES > Gerencial > Relatórios > Carteira)
// Fonte: Ucapital.pas + Uqrcapital.pas. PRD W-0627. ADRs 001/002/003/004.

const extrairMensagemErro = (err, fallback) =>
  (err && (err.message || err.Mensagem || err.message_error)) || fallback;

const CarteiraPorContaCapital = () => {
  const [gesDisponiveis, setGesDisponiveis] = useState([]);
  const [gesSelecionados, setGesSelecionados] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [resultado, setResultado] = useState(null);
  const [carregandoListas, setCarregandoListas] = useState(true);
  const [gerando, setGerando] = useState(false);
  const [exportando, setExportando] = useState(false);
  const [erro, setErro] = useState('');

  useEffect(() => {
    let ativo = true;
    setCarregandoListas(true);
    Promise.all([
      CarteiraService.obterGesDisponiveis(),
      CarteiraService.obterGruposGe(),
    ])
      .then(([resGes, resGrupos]) => {
        if (!ativo) return;
        setGesDisponiveis(Array.isArray(resGes) ? resGes : []);
        setGrupos(Array.isArray(resGrupos) ? resGrupos : []);
      })
      .catch((err) => {
        if (!ativo) return;
        const msg = extrairMensagemErro(err, 'Erro ao carregar GEs disponíveis.');
        setErro(msg);
        toast.error(msg);
      })
      .then(() => {
        if (ativo) setCarregandoListas(false);
      });
    return () => {
      ativo = false;
    };
  }, []);

  const handleGerar = async () => {
    setErro('');
    if (!gesSelecionados.length) {
      const msg = 'Selecione pelo menos um GE.';
      setErro(msg);
      toast.warn(msg);
      return;
    }
    setGerando(true);
    setResultado(null);
    try {
      const codigos = gesSelecionados.map((g) => g.codigo_grupo_empresa);
      const res = await CarteiraService.gerarRelatorio(codigos);
      const linhas = (res && res.linhas) || [];
      if (linhas.length === 0) {
        setErro('Nenhum registro encontrado para os GEs selecionados.');
      } else {
        setResultado(res);
      }
    } catch (err) {
      const msg = extrairMensagemErro(err, 'Erro ao gerar relatório.');
      setErro(msg);
      toast.error(msg);
    } finally {
      setGerando(false);
    }
  };

  const handleExportar = async () => {
    if (!resultado || !resultado.linhas || resultado.linhas.length === 0) return;

    setExportando(true);
    try {
      const codigos = gesSelecionados.map((g) => g.codigo_grupo_empresa);
      await CarteiraService.exportarExcel(codigos);
    } catch (err) {
      toast.error(extrairMensagemErro(err, 'Erro ao exportar relatório.'));
    } finally {
      setExportando(false);
    }
  };

  return (
    <Container fluid className="py-3">
      <Header title="Carteira por Conta Capital" />

      <Card className="mt-3">
        <Card.Body>
          {carregandoListas ? (
            <Loading label="Carregando GEs disponíveis..." />
          ) : (
            <>
              <CarteiraDualList
                gesDisponiveis={gesDisponiveis}
                gesSelecionados={gesSelecionados}
                grupos={grupos}
                onChangeSelecionados={setGesSelecionados}
              />

              <div className="mt-3">
                <Button
                  variant="primary"
                  onClick={handleGerar}
                  disabled={gerando || gesSelecionados.length === 0}
                >
                  {gerando ? 'Gerando...' : 'Gerar Relatório'}
                </Button>
              </div>
            </>
          )}
        </Card.Body>
      </Card>

      {gerando && <Loading label="Gerando relatório..." />}

      {!gerando && erro && (
        <Alert variant="warning" className="mt-3">
          {erro}
        </Alert>
      )}

      {!gerando && resultado && (
        <CarteiraResultadoTabela
          resultado={resultado}
          onExportar={handleExportar}
          exportando={exportando}
        />
      )}
    </Container>
  );
};

export default CarteiraPorContaCapital;
